function Header({ children }: { children: string }) {
  return (
    <h2 className="mb-4  text-2xl font-semibold text-navy-700 dark:text-white">
      {children}
    </h2>
  );
}

export default Header;
